(() => {
  const VOICE_TEST_MAX_SECONDS = 60;
  const ASSISTANT = '1f853594-804e-4a92-b700-2992797f9161';
  let loading;
  function loadSDK(url) {
    if (window.WidgetLoader) return Promise.resolve(window.WidgetLoader);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => { script.remove(); reject(new Error('sdk')); }, 15000);
      script.src = url;
      script.onload = () => { clearTimeout(timer); window.WidgetLoader ? resolve(window.WidgetLoader) : reject(new Error('sdk')); };
      script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('sdk')); };
      document.head.append(script);
    }).catch(error => { loading = null; throw error; });
    return loading;
  }
  function create(config, dependencies = {}) {
    const load = dependencies.load || loadSDK;
    const report = dependencies.report || (() => {});
    const schedule = dependencies.schedule || setTimeout, cancel = dependencies.cancel || clearTimeout;
    let voiceTimer, voiceUsed = false;
    function finishVoice(reason = 'voice_ended') {
      if (voiceTimer) cancel(voiceTimer); voiceTimer = null;
      voiceActive = false; const previous = loader; loader = null; previous?.destroy();
      set(reason); return true;
    }
    let loader, state = 'disabled', generation = 0, voiceActive = false;
    const valid = config.enabled === true && config.reviewed === true && !!config.publicKey &&
      config.assistantId === ASSISTANT && !!config.notice && !!config.sdkUrl;
    function set(next) { state = next; report(next); }
    if (valid) set('consent'); else set('disabled');
    async function connect(mode, consent) {
      if (!valid || consent !== true || !['chat', 'voice'].includes(mode) || state === 'loading' || loader) return false;
      if (config.voiceOnly === true && mode !== 'voice') return false;
      // Each new explicit customer start is allowed; no automatic session/reconnect.
      // Fail before SDK loading or microphone access until the documented override and SDK stop controls are statically verified.
      if (mode === 'voice' && config.voiceLimitVerified !== true) { set('voice_limit_unverified'); return false; }
      const current = ++generation;
      set('loading');
      try {
        const Loader = await load(config.sdkUrl);
        if (current !== generation) return false;
        loader = new Loader({container: config.container, component: 'VapiWidget', props: {
          publicKey: config.publicKey, assistantId: ASSISTANT, mode,
          ...(mode === 'voice' ? {assistantOverrides: {maxDurationSeconds: VOICE_TEST_MAX_SECONDS}} : {}),
          theme: 'light', size: 'full', radius: 'large', position: 'bottom-right',
          baseColor: '#F7F2EA', accentColor: '#A58B9D', buttonBaseColor: '#392C2D', buttonAccentColor: '#F7F2EA',
          mainLabel: config.labels.title, startButtonText: mode === 'voice' ? 'Start voice conversation' : config.labels.start, endButtonText: config.labels.end,
          requireConsent: false, termsContent: config.notice, localStorageKey: 'pocket_muse_support_consent_v1',
          voiceAutoReconnect: false, showTranscript: true,
          voiceEmptyMessage: 'Use Start voice conversation below. You can end the call at any time.',
          onCallStart: () => { voiceActive = true; set('voice_active');
            if (mode === 'voice') { voiceUsed = true; if (voiceTimer) cancel(voiceTimer); voiceTimer = schedule(() => finishVoice('voice_timeout'), VOICE_TEST_MAX_SECONDS * 1000); } },
          onCallEnd: () => { if (mode === 'voice') finishVoice(); else { voiceActive = false; set('ready'); } },
          onMessage: () => { if (!voiceActive) set('ready'); },
          onError: error => { const message = String(error?.message || '').toLowerCase(); set(message.includes('microphone') || message.includes('permission') ? 'microphone_denied' : 'error'); }
        }});
        set('ready');
        return true;
      } catch { set('error'); return false; }
    }
    function disconnect() {
      if (voiceActive) return false;
      generation++;
      loader?.destroy(); loader = null;
      set(valid ? 'consent' : 'disabled');
      return true;
    }
    return { connect, disconnect, endVoiceTest: () => finishVoice(), get state() { return state; }, get active() { return !!loader; } };
  }
  window.PocketMuseVapiConnection = { create };
})();
